<template>
  <nav>
    <router-link to="/auctions">Auctions</router-link>
    <router-link to="/about">How it works</router-link>
    <router-link v-if="currentUser.name" to="/signin"
      >Bidding as {{ currentUser.name }}</router-link
    >
    <router-link v-if="!currentUser.name" to="/signin">Sign in</router-link>
  </nav>
</template>

<script>
export default {
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
  },
};
</script>

<style scoped>
nav {
  text-align: center;
}
nav a {
  color: white;
  text-decoration: none;
}

nav a.router-link-active {
  text-decoration: underline;
}

nav a:hover {
  text-decoration: underline;
}

nav a + a {
  margin-left: 16px;
}
</style>